/**
 * Role-aware tab targets for assistant / notifications / tours.
 * Keep in sync with ROLE_META tabs in roles.ts and screenRegistry.
 */
import type { Role } from '../constants/roles';
import { ROLE_META, ROLES } from '../constants/roles';

export interface NavTabMeta {
  role: Role;
  tab: string;
  target: string;
}

export function listNavTargetsForRole(role?: string): NavTabMeta[] {
  if (!role || !(role in ROLE_META)) return [];
  const r = role as Role;
  const tabs = ROLE_META[r]?.tabs ?? [];
  return tabs.map((tab) => ({ role: r, tab, target: `${r}:${tab}` }));
}

export function isValidNavTarget(target: string, role?: string): boolean {
  if (!target.includes(':')) return false;
  const [prefix, tab] = target.split(':');
  if (!tab) return false;
  if (role === ROLES.GOD) {
    // God may navigate own tabs or house-scoped banker tabs while scoped.
    return listNavTargetsForRole(ROLES.GOD).some((t) => t.target === target)
      || listNavTargetsForRole(ROLES.BANKER).some((t) => t.tab === tab);
  }
  if (prefix !== role) return false;
  return listNavTargetsForRole(role).some((t) => t.target === target);
}

export function parseNavTab(target: string): string | null {
  const [, tab] = target.split(':');
  return tab || null;
}
